/*!
 * @pixi/filter-old-film - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-old-film is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */import { Filter as c } from "@pixi/core";
var l = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`,
  d = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform vec4 filterArea;
uniform vec2 dimensions;

uniform float sepia;
uniform float noise;
uniform float noiseSize;
uniform float scratch;
uniform float scratchDensity;
uniform float scratchWidth;
uniform float vignetting;
uniform float vignettingAlpha;
uniform float vignettingBlur;
uniform float seed;

const float SQRT_2 = 1.414213;
const vec3 SEPIA_RGB = vec3(112.0 / 255.0, 66.0 / 255.0, 20.0 / 255.0);

float rand(vec2 co) {
    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);
}

vec3 Overlay(vec3 src, vec3 dst)
{
    // if (dst <= 0.5) then: 2 * src * dst
    // if (dst > 0.5) then: 1 - 2 * (1 - dst) * (1 - src)
    return vec3((dst.x <= 0.5) ? (2.0 * src.x * dst.x) : (1.0 - 2.0 * (1.0 - dst.x) * (1.0 - src.x)),
                (dst.y <= 0.5) ? (2.0 * src.y * dst.y) : (1.0 - 2.0 * (1.0 - dst.y) * (1.0 - src.y)),
                (dst.z <= 0.5) ? (2.0 * src.z * dst.z) : (1.0 - 2.0 * (1.0 - dst.z) * (1.0 - src.z)));
}


void main()
{
    gl_FragColor = texture2D(uSampler, vTextureCoord);
    vec3 color = gl_FragColor.rgb;

    if (sepia > 0.0)
    {
        float gray = (color.x + color.y + color.z) / 3.0;
        vec3 grayscale = vec3(gray);

        color = Overlay(SEPIA_RGB, grayscale);

        color = grayscale + sepia * (color - grayscale);
    }

    vec2 coord = vTextureCoord * filterArea.xy / dimensions.xy;

    if (vignetting > 0.0)
    {
        float outter = SQRT_2 - vignetting * SQRT_2;
        vec2 dir = vec2(vec2(0.5, 0.5) - coord);
        dir.y *= dimensions.y / dimensions.x;
        float darker = clamp((outter - length(dir) * SQRT_2) / ( 0.00001 + vignettingBlur * SQRT_2), 0.0, 1.0);
        color.rgb *= darker + (1.0 - darker) * (1.0 - vignettingAlpha);
    }

    if (scratchDensity > seed && scratch != 0.0)
    {
        float phase = seed * 256.0;
        float s = mod(floor(phase), 2.0);
        float dist = 1.0 / scratchDensity;
        float d = distance(coord, vec2(seed * dist, abs(s - seed * dist)));
        if (d < seed * 0.6 + 0.4)
        {
            highp float period = scratchDensity * 10.0;

            float xx = coord.x * period + phase;
            float aa = abs(mod(xx, 0.5) * 4.0);
            float bb = mod(floor(xx / 0.5), 2.0);
            float yy = (1.0 - bb) * aa + bb * (2.0 - aa);

            float kk = 2.0 * period;
            float dw = scratchWidth / dimensions.x * (0.75 + seed);
            float dh = dw * kk;

            float tine = (yy - (2.0 - dh));

            if (tine > 0.0) {
                float _sign = sign(scratch);

                tine = s * tine / period + scratch + 0.1;
                tine = clamp(tine + 1.0, 0.5 + _sign * 0.5, 1.5 + _sign * 0.5);

                color.rgb *= tine;
            }
        }
    }

    if (noise > 0.0 && noiseSize > 0.0)
    {
        vec2 pixelCoord = vTextureCoord.xy * filterArea.xy;
        pixelCoord.x = floor(pixelCoord.x / noiseSize);
        pixelCoord.y = floor(pixelCoord.y / noiseSize);
        // vec2 d = pixelCoord * noiseSize * vec2(1024.0 + seed * 512.0, 1024.0 - seed * 512.0);
        // float _noise = snoise(d) * 0.5;
        float _noise = rand(pixelCoord * noiseSize * seed) - 0.5;
        color += _noise * noise;
    }

    gl_FragColor.rgb = color;
}
`;
const s = class extends c {
  constructor(n, i = 0) {
    super(l, d), this.seed = 0, this.uniforms.dimensions = new Float32Array(2), typeof n == "number" ? (this.seed = n, n = void 0) : this.seed = i, Object.assign(this, s.defaults, n);
  }
  apply(n, i, o, a) {
    var t, e;
    this.uniforms.dimensions[0] = (t = i.filterFrame) == null ? void 0 : t.width, this.uniforms.dimensions[1] = (e = i.filterFrame) == null ? void 0 : e.height, this.uniforms.seed = this.seed, n.applyFilter(this, i, o, a);
  }
  set sepia(n) {
    this.uniforms.sepia = n;
  }
  get sepia() {
    return this.uniforms.sepia;
  }
  set noise(n) {
    this.uniforms.noise = n;
  }
  get noise() {
    return this.uniforms.noise;
  }
  set noiseSize(n) {
    this.uniforms.noiseSize = n;
  }
  get noiseSize() {
    return this.uniforms.noiseSize;
  }
  set scratch(n) {
    this.uniforms.scratch = n;
  }
  get scratch() {
    return this.uniforms.scratch;
  }
  set scratchDensity(n) {
    this.uniforms.scratchDensity = n;
  }
  get scratchDensity() {
    return this.uniforms.scratchDensity;
  }
  set scratchWidth(n) {
    this.uniforms.scratchWidth = n;
  }
  get scratchWidth() {
    return this.uniforms.scratchWidth;
  }
  set vignetting(n) {
    this.uniforms.vignetting = n;
  }
  get vignetting() {
    return this.uniforms.vignetting;
  }
  set vignettingAlpha(n) {
    this.uniforms.vignettingAlpha = n;
  }
  get vignettingAlpha() {
    return this.uniforms.vignettingAlpha;
  }
  set vignettingBlur(n) {
    this.uniforms.vignettingBlur = n;
  }
  get vignettingBlur() {
    return this.uniforms.vignettingBlur;
  }
};
let r = s;
r.defaults = {
  sepia: .3,
  noise: .3,
  noiseSize: 1,
  scratch: .5,
  scratchDensity: .3,
  scratchWidth: 1,
  vignetting: .3,
  vignettingAlpha: 1,
  vignettingBlur: .3
};
export { r as OldFilmFilter };
